import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./authentication.css";
import {
    ApiDetails,
    KEY,
    SITE_KEY,
    SKY_AUTH_ApiDetails,
} from "../../dummyData";
import { fetchEventSource } from "@microsoft/fetch-event-source";
import LoadingButton from "@mui/lab/LoadingButton";
import logo from "../../assets/react-logo-no-background.svg";
import wave from "../../assets/login_background_3.mp4";
import {
    TextField,
    InputAdornment,
    Card,
    CardContent,
    Typography,
    Box,
    Container,
    Grid,
    IconButton,
    Paper,
    Divider,
    Link,
    FormHelperText,
    FormControl,
} from "@mui/material";
import {
    Login as LoginIcon,
    Visibility as VisibilityIcon,
    VisibilityOff as VisibilityOffIcon,
    LockOutlined,
    Email as EmailIcon,
    AccountCircle as AccountCircleIcon
} from "@mui/icons-material";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Autocomplete } from "@mui/material";

export default function LoginPage(props) {
    let CryptoJS = require("crypto-js");
    const handleClose = () => {};

    let userData = 0;

    const navigate = useNavigate();
    const [userTypes, setUserTypes] = React.useState([]);
    const [selectedUserType, setSelectedUserType] = React.useState();
    const [, setCaptcha] = useState(<div></div>);

    const [loading, setLoading] = React.useState(false);
    const [loadingAuthentication, setLoadingAuthentication] = React.useState(false);
    const [proceed, setProceed] = React.useState(false);

    // Fetch user types on component mount
    useEffect(() => {
        fetch(ApiDetails + "pegasus/visionary/extras/user_types", {
            method: "GET",
        })
            .then(async (response) => {
                let data = await response.json();
                if (response.status === 200) {
                    setUserTypes(data);
                } else {
                    props.snackBar({
                        text: "Something went wrong.",
                        type: "error",
                    });
                }
            })
            .catch((err) => {
                console.log(err);
                props.snackBar({
                    text: "Something Went Wrong. Try Again Later",
                    type: "error",
                });
            });

        setCaptcha(<div className="g-recaptcha" data-sitekey={SITE_KEY}></div>);
    }, []);

    // Handle 2FA verification
    const confirmAuthCode = async (event, email) => {
        event.preventDefault();
        setLoadingAuthentication(true);
        let code = document.getElementById("auth_code").value;
        if (code === "") {
            setLoadingAuthentication(false);
            props.snackBar({
                text: "Code Can Not Be Empty.",
                type: "error",
            });
            return;
        }

        let body = {
            auth_code: code,
            identifier_type: "MAIL",
            identifier: email,
            program_id: parseInt("100009"),
        };

        fetch(SKY_AUTH_ApiDetails + "/sky-auth/confirmation", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "token": "8d5b2e7c-36f4-4b45-b79b-61fc60eb905d"
            },
            body: JSON.stringify(body),
        })
            .then(async (response) => {
                if (response.status === 200) {
                    handleClose();
                    getUserDetails(userData);
                    setLoadingAuthentication(false);
                } else {
                    props.snackBar({
                        text: "Invalid Code Provided.",
                        type: "error",
                    });
                    setLoadingAuthentication(false);
                }
            })
            .catch((err) => {
                console.log(err);
                props.snackBar({
                    text: "Something Went Wrong. Try Again Later",
                    type: "error",
                });
                setLoadingAuthentication(false);
            });
    };

    // Handle login form submission
    const onSubmit = (values) => {
        setLoading(true);
        if (selectedUserType === undefined || selectedUserType === null) {
            props.snackBar({
                text: "Kindly select user type",
                type: "error",
            });
            setLoading(false);
            return;
        }

        values = { ...values, user_type: selectedUserType.id };

        fetch(ApiDetails + "pegasus/visionary/authorization/login", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "token": "8d5b2e7c-36f4-4b45-b79b-61fc60eb905d"
            },
            body: JSON.stringify(values),
        })
            .then(async (response) => {
                let data = await response.json();
                userData = data;
                console.log(response.status);

                if (response.status === 200) {
                    let two_fa = new Map(Object.entries(data)).get("two_factor_enabled");

                    if (two_fa === "YES") {
                        //Create SSE Connection
                        try {
                            await fetchEventSource(
                                SKY_AUTH_ApiDetails + "/sky-auth/confirmation/sse/100009",
                                {
                                    method: "GET",
                                    headers: {
                                        Accept: "text/event-stream",
                                    },
                                    onopen(res) {
                                        if (res.ok && res.status === 200) {
                                            //Get Qr Code
                                            const body = {
                                                identifier_type: "MAIL",
                                                identifier: values.email_address,
                                                program_id: parseInt("100009"),
                                            };
                                            fetch(
                                                SKY_AUTH_ApiDetails + "/sky-auth/authorization/biometric/add",
                                                {
                                                    method: "POST",
                                                    body: JSON.stringify(body),
                                                }
                                            )
                                                .then(async (response) => {
                                                    let data = await response.json();
                                                    if (response.status === 200) {
                                                        let base_64_image = new Map(
                                                            Object.entries(data)
                                                        ).get("Base64 QR image");

                                                        setLoginPage(
                                                            <Container maxWidth="md">
                                                                <Card elevation={5} sx={{ overflow: "hidden", borderRadius: 3, my: 4 }}>
                                                                    <Grid container>
                                                                        <Grid item xs={12} md={6}>
                                                                            <CardContent sx={{ p: 4, height: "100%", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                                                                                <Typography variant="h5" component="h2" gutterBottom>
                                                                                    Two-Factor Authentication
                                                                                </Typography>
                                                                                <Typography variant="body2" color="text.secondary" paragraph>
                                                                                    Please enter the authentication code or scan the QR code with your authenticator app.
                                                                                </Typography>

                                                                                <form id="form">
                                                                                    <TextField
                                                                                        fullWidth
                                                                                        margin="normal"
                                                                                        label="Authentication Code"
                                                                                        variant="outlined"
                                                                                        type="number"
                                                                                        id="auth_code"
                                                                                        InputProps={{
                                                                                            startAdornment: (
                                                                                                <InputAdornment position="start">
                                                                                                    <LockOutlined />
                                                                                                </InputAdornment>
                                                                                            ),
                                                                                        }}
                                                                                    />

                                                                                    <LoadingButton
                                                                                        endIcon={<LoginIcon />}
                                                                                        loading={loadingAuthentication}
                                                                                        loadingPosition="end"
                                                                                        variant="contained"
                                                                                        fullWidth
                                                                                        size="large"
                                                                                        onClick={(event) => {
                                                                                            confirmAuthCode(event, values.email_address, data);
                                                                                        }}
                                                                                        sx={{ mt: 2, mb: 2, borderRadius: 2 }}
                                                                                    >
                                                                                        Verify Code
                                                                                    </LoadingButton>

                                                                                    <FormHelperText error>
                                                                                        Kindly enter auth code or scan the QR code before the timer expires
                                                                                    </FormHelperText>
                                                                                </form>
                                                                            </CardContent>
                                                                        </Grid>

                                                                        <Grid item xs={12} md={6} sx={{ display: "flex", alignItems: "center", justifyContent: "center", bgcolor: "#f5f5f5" }}>
                                                                            <Box sx={{ p: 4, textAlign: "center" }}>
                                                                                <Typography variant="h6" gutterBottom>
                                                                                    Scan QR Code
                                                                                </Typography>
                                                                                <Box sx={{ mt: 2, p: 2, bgcolor: "white", display: "inline-block", borderRadius: 2 }}>
                                                                                    <img
                                                                                        src={"data:image/png;base64," + base_64_image}
                                                                                        alt="QR Code for Authentication"
                                                                                        style={{ maxWidth: "200px" }}
                                                                                    />
                                                                                </Box>
                                                                            </Box>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Card>
                                                            </Container>
                                                        );
                                                        setProceed(true);
                                                    } else {
                                                        props.snackBar({
                                                            text: "Invalid Code Provided.",
                                                            type: "error",
                                                        });
                                                        setLoading(false);
                                                    }
                                                })
                                                .catch((err) => {
                                                    console.log(err);
                                                    props.snackBar({
                                                        text: "Something Went Wrong. Try Again Later",
                                                        type: "error",
                                                    });
                                                });
                                        } else if (
                                            res.status >= 400 &&
                                            res.status < 500 &&
                                            res.status !== 429
                                        ) {
                                            console.log("Client side error ", res);
                                        }
                                    },
                                    onmessage() {
                                        console.log("Code confirmed successfully");
                                        handleClose();
                                        getUserDetails(data);
                                    },
                                    onclose() {
                                        console.log("Connection closed by the server retrying ... ");
                                    },
                                    onerror(err) {
                                        console.log("There was an error from server", err);
                                    },
                                }
                            );
                        } catch (e) {
                            console.log(e);
                        }
                    } else {
                        handleClose();
                        getUserDetails(data);
                    }
                } else if (response.status === 401) {
                    setLoading(false);
                    props.snackBar({
                        text: "Maximum concurrent logins reached",
                        type: "warning",
                    });
                } else if (response.status === 400) {
                    props.snackBar({
                        text: "Invalid Credentials Provided.",
                        type: "error",
                    });
                    setLoading(false);
                }
            })
            .catch((err) => {
                setLoading(false);
                console.log(err);
                props.snackBar({
                    text: "Something Went Wrong. Try Again Later",
                    type: "error",
                });
            });
    };

    // Get user details after successful login
    const getUserDetails = (userDetails) => {
        fetch(ApiDetails + "pegasus/visionary/dashboard/get/details", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "token": "8d5b2e7c-36f4-4b45-b79b-61fc60eb905d"
            },
            body: JSON.stringify(userDetails),
        })
            .then(async (response) => {
                let data = await response.json();
                if (response.status === 200) {
                    setLoading(false);

                    const map1 = new Map(Object.entries(data));
                    const details = new Map(Object.entries(userDetails));
                    const subscription = new Map();

                    subscription.set("subscription_expired", details.get("subscription_expired"));
                    subscription.set("subscription_amount", details.get("subscription_amount"));

                    let myMap = CryptoJS.AES.encrypt(
                        JSON.stringify(Array.from(details.entries())),
                        KEY
                    ).toString();
                    let portfolioDetails = CryptoJS.AES.encrypt(
                        JSON.stringify(Array.from(map1.entries())),
                        KEY
                    ).toString();

                    let subscriptionDetails = CryptoJS.AES.encrypt(
                        JSON.stringify(Array.from(subscription.entries())),
                        KEY
                    ).toString();

                    localStorage.setItem("myMap", myMap);
                    localStorage.setItem("isNew", userDetails.new);
                    localStorage.portfolioDetails = portfolioDetails;
                    localStorage.subscriptionDetails = subscriptionDetails;

                   /* navigate("/home", {
                        state: {
                            userDetails: userDetails,
                        },
                    });*/
                    props.snackBar({ text: "Login Successful", type: "success" });
                    props.refresh(true);
                    props.fn();
                } else {
                    setLoading(false);
                    props.snackBar({ text: "Failed Fetching Details", type: "error" });
                }
            })
            .catch((err) => {
                setLoading(false);
                console.log(err);
            });
    };

    localStorage.clear();
    const [loginPage, setLoginPage] = useState();

    const initialValues = {
        email_address: "",
        password: "",
    };

    const validationSchema = Yup.object().shape({
        email_address: Yup.string()
            .email("Invalid email address")
            .required("Email address is required"),
        password: Yup.string().required("Password is required"),
    });

    const [showPassword, setShowPassword] = useState(false);

    return (
        <Box
            sx={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
            }}
        >
            {/* Video Background */}
            <video
                autoPlay
                loop
                muted
                preload={"auto"}
                style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    position: "absolute",
                    zIndex: -1,
                }}
            >
                <source src={wave} type="video/mp4" />
            </video>

            {/* Main Content */}
            <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
                {proceed ? (
                    <>{loginPage}</>
                ) : (
                    <Card
                        elevation={10}
                        sx={{
                            borderRadius: 4,
                            overflow: "hidden",
                            width: "100%",
                            maxWidth: "1000px",
                            mx: "auto",
                            backgroundColor: "rgba(255, 255, 255, 0.95)",
                            backdropFilter: "blur(10px)",
                        }}
                    >
                        <Grid container>
                            {/* Form Section */}
                            <Grid
                                item
                                xs={12}
                                md={6}
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    p: 4,
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        mb: 4
                                    }}
                                >
                                    <img
                                        src={logo}
                                        alt="Company Logo"
                                        style={{
                                            width: "180px",
                                            marginBottom: "20px",
                                        }}
                                    />
                                    <Typography variant="h4" component="h1" fontWeight="bold">
                                        Welcome Back
                                    </Typography>
                                    <Typography variant="body1" color="text.secondary">
                                        Sign in to your property management account
                                    </Typography>
                                </Box>

                                <Formik
                                    initialValues={initialValues}
                                    validationSchema={validationSchema}
                                    onSubmit={onSubmit}
                                >
                                    {(formikProps) => (
                                        <Form noValidate>
                                            <Field name="email_address">
                                                {({ field, meta }) => (
                                                    <FormControl fullWidth sx={{ mb: 2 }}>
                                                        <TextField
                                                            {...field}
                                                            type="email"
                                                            label="Email Address"
                                                            variant="outlined"
                                                            error={meta.touched && Boolean(meta.error)}
                                                            helperText={meta.touched && meta.error}
                                                            InputProps={{
                                                                startAdornment: (
                                                                    <InputAdornment position="start">
                                                                        <EmailIcon color="primary" />
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                        />
                                                    </FormControl>
                                                )}
                                            </Field>

                                            <Field name="password">
                                                {({ field, meta }) => (
                                                    <FormControl fullWidth sx={{ mb: 2 }}>
                                                        <TextField
                                                            {...field}
                                                            type={showPassword ? "text" : "password"}
                                                            label="Password"
                                                            variant="outlined"
                                                            error={meta.touched && Boolean(meta.error)}
                                                            helperText={meta.touched && meta.error}
                                                            InputProps={{
                                                                startAdornment: (
                                                                    <InputAdornment position="start">
                                                                        <LockOutlined color="primary" />
                                                                    </InputAdornment>
                                                                ),
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        <IconButton
                                                                            aria-label="toggle password visibility"
                                                                            onClick={() => setShowPassword(!showPassword)}
                                                                            edge="end"
                                                                        >
                                                                            {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                                                        </IconButton>
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                        />
                                                    </FormControl>
                                                )}
                                            </Field>

                                            <Autocomplete
                                                disablePortal
                                                id="account-type-select"
                                                options={userTypes.map((type) => type.description)}
                                                onChange={(e, value) => {
                                                    setSelectedUserType(
                                                        userTypes.filter((type) => {
                                                            if (type.description === value) {
                                                                return type.id;
                                                            }
                                                        })[0]
                                                    );
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Account Type"
                                                        variant="outlined"
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            startAdornment: (
                                                                <>
                                                                    <InputAdornment position="start">
                                                                        <AccountCircleIcon color="primary" />
                                                                    </InputAdornment>
                                                                    {params.InputProps.startAdornment}
                                                                </>
                                                            ),
                                                        }}
                                                    />
                                                )}
                                                sx={{ mb: 3 }}
                                            />

                                            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
                                                <Link href="#" variant="body2">
                                                    Forgot password?
                                                </Link>
                                            </Box>

                                            <LoadingButton
                                                type="submit"
                                                variant="contained"
                                                fullWidth
                                                size="large"
                                                loading={loading}
                                                loadingPosition="end"
                                                endIcon={<LoginIcon />}
                                                sx={{
                                                    py: 1.5,
                                                    borderRadius: 2,
                                                    mb: 2,
                                                    fontWeight: "bold"
                                                }}
                                            >
                                                Sign In
                                            </LoadingButton>

                                            <Divider sx={{ my: 3 }}>
                                                <Typography variant="body2" color="text.secondary">
                                                    OR
                                                </Typography>
                                            </Divider>

                                            <Box sx={{ textAlign: "center" }}>
                                                <Typography variant="body2">
                                                    Don't have an account?{" "}
                                                    <Link href="/signup" fontWeight="bold" underline="hover">
                                                        Create Account
                                                    </Link>
                                                </Typography>
                                            </Box>
                                        </Form>
                                    )}
                                </Formik>
                            </Grid>

                            {/* Image Section */}
                            <Grid
                                item
                                xs={12}
                                md={6}
                                sx={{
                                    display: { xs: "none", md: "block" },
                                    position: "relative",
                                }}
                            >
                                <Box
                                    component="img"
                                    src={require("../../assets/new_landlord_login_pic.jpg")}
                                    alt="Property Management"
                                    sx={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        objectPosition: "center",
                                    }}
                                />
                                <Box
                                    sx={{
                                        position: "absolute",
                                        bottom: 0,
                                        left: 0,
                                        right: 0,
                                        p: 4,
                                        background: "linear-gradient(to top, rgba(0,0,0,0.7), rgba(0,0,0,0))",
                                        color: "white",
                                    }}
                                >
                                    <Typography variant="h5" fontWeight="bold" gutterBottom>
                                        Manage Your Properties Efficiently
                                    </Typography>
                                    <Typography variant="body1">
                                        Access your dashboard to view reports, track maintenance, and manage tenants all in one place.
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Card>
                )}
            </Container>
        </Box>
    );
}